import request from '@/utils/request'

// 服务摄影列表
export const listServicePhotography = (pageData, formData) => {
  return request.get(`/servicePhotography/page/${pageData.page}/${pageData.pageSize}`, { params: formData })
}

// 服务摄影详情
export const listServicePhotographyDetail = (id) => {
  return request.get(`/servicePhotography/${id}`)
}

// 新增服务摄影
export const addServicePhotography = (formData) => {
  return request.post('/servicePhotography', formData)
}

// 修改服务摄影
export const editServicePhotography = (formData) => {
  return request.put('/servicePhotography', formData)
}

// 删除服务摄影
export const deleteServicePhotography = (id) => {
  return request.delete(`/servicePhotography/${id}`)
}